module.exports = __webpack_public_path__ + "img/new-user-header-new.a3d3bfee.png";